import { RetunOrderSelectModel, ReturnOrderParams, returnProducts } from "@NA/Services/ADIReturnSelectService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<any, any>;

export const DispatchLoadReturnProducts: HandlerType = props => {
    props.dispatch({
        type: "Custom/returnProducts",
        result: props.parameter,
    });
};

export const returnProductsHandler: HandlerType = async props => {
    props.apiResult = await returnProducts(props.parameter);
    sessionStorage.setItem("returnProductsLabels", JSON.stringify(props.apiResult));  
};

export const DispatchCompleteLoadReturnConfirmedProducts: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteReturnProducts",
        result: props.apiResult,
    });
};

export const chain = [DispatchLoadReturnProducts, returnProductsHandler, DispatchCompleteLoadReturnConfirmedProducts];

const loadReturnConfirmedProducts = createHandlerChainRunner(chain, "loadReturnConfirmedProducts");
export default loadReturnConfirmedProducts;
